import script from "./port-manage.vue?vue&type=script&lang=ts&setup=true"
export * from "./port-manage.vue?vue&type=script&lang=ts&setup=true"

import "./port-manage.vue?vue&type=style&index=0&id=9832c7c8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9832c7c8"]])

export default __exports__